import CustomTable from "Component/CustomTable";
import { useState, useEffect } from "react";
import { Notify } from "Component/Notify";
import { fetchApi } from "Config/fetchApi";
import { DraggableModal } from "Component/Modal/index";
import { TablePagination } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "Route/ConstantRoute";
import { EncryptStorage } from "encrypt-storage";
import { handleError } from "Helper";

function DockingStationSettings() {
  const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  const userInfo = encryptStorage.getItem("___info");
  const permission_flag =
    userInfo?.permission_flag != undefined
      ? JSON.parse(userInfo?.permission_flag)
      : {};
  const yuridiksi_user_code = userInfo?.jurisdiction_level_code || "";
  const organisasi_user_id = userInfo?.organization_id || "";
  const navigate = useNavigate();
  // ==================== Pengaturan Modal ==================== //
  const [openModal, setOpenModal] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  // ==================== Pengaturan Modal ==================== //

  const [uuid, setUuid] = useState("");
  const [detailData, setDetailData] = useState({});
  const [keywordSearch, setDataKeyword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [headerTable] = useState([
    {
      label: "Nama Perangkat",
      key: "docking_station_name",
      align: "center",
    },
    {
      label: "IP Address",
      key: "docking_station_ip_address",
      align: "center",
    },
    {
      label: "Organisasi Penanggung Jawab",
      key: "docking_station_organization_name",
      align: "center",
    },
  ]);
  const [isActionTable] = useState({
    isAdd: permission_flag?.streaming?.addData || false,
    isEdit: permission_flag?.streaming?.updateData || false,
    isShow: true,
    isDelete: permission_flag?.streaming?.deleteData || false,
  });

  // ==================== Pengaturan Pagination ==================== //
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  // ==================== Pengaturan Pagination ==================== //

  // ==================== Default ==================== //
  const handleSuccess = (message) => {
    Notify.success({
      title: "Berhasil",
      description: message,
    });
  };

  const getData = async () => {
    try {
      setIsLoading(true);
      const paramCari = `keywords=${keywordSearch}`;
      const paramPage = `page=${pageNumber}`;
      const paramSize = `size=${pageSize}`;
      const organizationParam = `organizationId=${yuridiksi_user_code === "N" ? "" : organisasi_user_id}`;
      const response = await fetchApi().get(
        `/docking-station/get-list?${paramCari}&${organizationParam}&${paramPage}&${paramSize}`
      );
      setData(response?.data || {});
      setPageNumber(response.data?.currentPage || 0);
      setPageSize(response.data?.size || 15);
      setIsLoading(false);
    } catch (err) {
      setData([]);
      setIsLoading(false);
      handleError(err);
    }
  };
  const deleteData = async () => {
    try {
      setIsLoading(true);
      const response = await fetchApi().delete(
        `/docking-station/delete/${uuid}`
      );
      setIsLoading(false);
      handleSuccess(response.data?.message);
      getData();
      setOpenModalDelete(!openModalDelete);
    } catch (err) {
      setOpenModalDelete(!openModalDelete);
      setIsLoading(false);
      handleError(err);
    }
  };
  // ==================== Default ==================== //

  useEffect(() => {
    getData();
  }, [keywordSearch, pageNumber, pageSize]);
  // ==================== Default ==================== //

  return (
    <div>
      <div className="text-lg font-bold text-start gap-2 pb-5">
        <p
          className="text-2xl font-bold"
          style={{
            fontFamily: "Poppins",
          }}
        >
          Pengaturan Docking Station
        </p>
      </div>
      <CustomTable
        onClickCreate={() =>
          navigate(
            ROUTES.management_data.docking_station.docking_station_create
          )
        }
        isAction={isActionTable}
        onEditData={(data) =>
          navigate(
            ROUTES.management_data.docking_station.docking_station_update,
            {
              state: data,
            }
          )
        }
        onClickShow={(data) => {
          setDetailData(data);
          setOpenModal(!openModal);
        }}
        onDeleteData={(data) => {
          setUuid(data?.id);
          setOpenModalDelete(!openModalDelete);
        }}
        isLoading={isLoading}
        headerData={headerTable}
        Data={data?.data || []}
        onSearchData={(keyword) => {
          setDataKeyword(keyword);
        }}
        TablePagination={
          <TablePagination
            rowsPerPageOptions={[15, 20, 30, 50]}
            component="div"
            count={data?.data?.length || 0}
            rowsPerPage={pageSize}
            page={pageNumber}
            onPageChange={(event, newPage) => {
              setPageNumber(newPage);
            }}
            onRowsPerPageChange={(event) => {
              setPageSize(event.target.value);
            }}
          />
        }
      />

      {/* Modal Detail Data */}
      <DraggableModal size="md" open={openModal} toggleModal={() => {}}>
        <DraggableModal.Header className="capitalize">
          <div className="flex gap-4 items-center justify-between">
            <p
              className="text-2xl font-bold"
              style={{
                fontFamily: "Poppins",
              }}
            >
              Detail Data
            </p>
            <button
              className="h-10 flex w-auto justify-center items-center rounded-xl hover:bg-neutral-100 px-3 py-1.5 text-xl font-semibold leading-6 text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              onClick={() => setOpenModal(!openModal)}
            >
              <i className="ri-close-line"></i>
            </button>
          </div>
        </DraggableModal.Header>
        <DraggableModal.Body>
          <div className="flex justify-between items-start py-5 px-5 w-full">
            <div className="mb-2 w-2/4 mr-5">
              <label
                htmlFor="app_name"
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-sm block font-bold leading-6"
              >
                Nama Docking Station
              </label>
              <p
                className="text-md font-medium"
                style={{
                  fontFamily: "Poppins",
                }}
              >
                {detailData?.docking_station_name || "-"}
              </p>
            </div>

            <div className="mb-2 w-2/4 mr-5">
              <label
                htmlFor="app_name"
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-sm block font-bold leading-6"
              >
                IP Address
              </label>
              <p
                className="text-md font-medium"
                style={{
                  fontFamily: "Poppins",
                }}
              >
                {detailData?.docking_station_ip_address || "-"}
              </p>
            </div>

            <div className="mb-2 w-2/4 mr-5">
              <label
                htmlFor="app_name"
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-sm block font-bold leading-6"
              >
                Organisasi Penanggung Jawab
              </label>
              <p
                className="text-md font-medium"
                style={{
                  fontFamily: "Poppins",
                }}
              >
                {detailData?.docking_station_organization_name || "-"}
              </p>
            </div>
          </div>
        </DraggableModal.Body>
        <DraggableModal.Footer>
          <div className="flex gap-4 items-center justify-end">
            <button
              onClick={() => setOpenModal(!openModal)}
              className="h-11 flex w-auto justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              Tutup
            </button>
          </div>
        </DraggableModal.Footer>
      </DraggableModal>

      {/* Modal Confirm Delete */}
      <DraggableModal
        size="sm-md"
        open={openModalDelete}
        toggleModal={() => {}}
      >
        <DraggableModal.Header className="capitalize">
          <div className="flex gap-4 items-center justify-between">
            <p
              className="text-2xl font-bold"
              style={{
                fontFamily: "Poppins",
              }}
            >
              Hapus Data
            </p>
            <button
              className="h-10 flex w-auto justify-center items-center rounded-xl hover:bg-neutral-100 px-3 py-1.5 text-xl font-semibold leading-6 text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              onClick={() => setOpenModalDelete(!openModalDelete)}
            >
              <i className="ri-close-line"></i>
            </button>
          </div>
        </DraggableModal.Header>
        <DraggableModal.Body>
          <div className="w-full text-lg font-bold text-start">
            <p
              className="text-md font-medium"
              style={{
                fontFamily: "Poppins",
              }}
            >
              Apakah Anda yakin ingin menghapus data ini ?
            </p>
          </div>
        </DraggableModal.Body>
        <DraggableModal.Footer>
          <div className="flex gap-4 items-center justify-end">
            <button
              className="h-11 flex w-auto justify-center items-center rounded-xl hover:bg-neutral-100 px-3 py-1.5 text-sm font-semibold leading-6 text-black  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              onClick={() => setOpenModalDelete(!openModalDelete)}
            >
              Tutup
            </button>
            <button
              onClick={deleteData}
              className="h-11 flex w-auto justify-center items-center rounded-xl bg-rose-900 hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              Hapus
            </button>
          </div>
        </DraggableModal.Footer>
      </DraggableModal>
    </div>
  );
}

export default DockingStationSettings;
